/**
 * Extend a target object with the props of one or more source objects
 * @param  {Object}    target  – target object
 * @param  {...Object} sources – source objects
 * @return {Object}            – the modified target object
 */

export default function extend( target, ...sources ) {
  sources.forEach( source => {
    Object.keys( source ).forEach( key => {
      target[ key ] = source[ key ];
    });
  });
  return target;
}
